// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import { createAsyncAction } from 'typesafe-actions';

export interface SendVisitedChallengeRequestPayload {
  id: number; // challenge id
}

export type SendVisitedChallengeSuccessPayload = {}

export interface SendVisitedChallengeFailPayload {
  error: Error;
}

const sendVisitedChallengeActions = createAsyncAction(
  'elearning/SEND_VISITED_CHALLENGE_REQUEST',
  'elearning/SEND_VISITED_CHALLENGE_SUCCESS',
  'elearning/SEND_VISITED_CHALLENGE_FAIL'
)<SendVisitedChallengeRequestPayload, SendVisitedChallengeSuccessPayload, SendVisitedChallengeFailPayload>();

export { sendVisitedChallengeActions as default};
